import SalesAssessmentComponent from '../SalesAssessmentComponent.vue'
import SalesAssessmentsAdmin from '../admin/SalesAssessmentsAdmin.vue'

export default [
    {
        // Public candidate assessment: the shareable link. No login; the
        // candidate gives a name and email. Optional ?source= tags the link.
        path: '/work-style',
        // The old link keeps working. The neutral path and title stop
        // candidates answering "with their sales hat on".
        alias: '/sales-assessment',
        name: 'SalesAssessment',
        meta: { layout: 'blank', hideAppBar: true },
        component: SalesAssessmentComponent,
    },
    {
        // Recruiter dashboard: recruitment access or Super Admin.
        path: '/sales-assessments',
        name: 'SalesAssessments',
        meta: { layout: 'default', requiresAssessmentAccess: true },
        component: SalesAssessmentsAdmin,
    },
]
